import _ from 'lodash';
import config from 'client/shared/config';
import { toast } from 'react-toastify';

import {
	observable,
	action,
	computed,
	runInAction
} from 'mobx';

import { BaseStore } from 'common/stores';
// import Playlist from '../schemas/playlist';
// import config from 'client/shared/config';
import songsStore from './songs-store';
const { routes } = config;

class PlaylistStore extends BaseStore {
	apiRoute = routes.playlists;

		/**
	 * Observables & Computeds
	 */

	@observable
	_playlistModalOpen = false;

	@computed
	get playlistModalOpen () {
		return this._playlistModalOpen;
	}

	set playlistModalOpen (isOpen) {
		this._playlistModalOpen = isOpen;
	}

	@computed
	get data () {
		if (_.isEmpty(this._data.item)) {

			this._data.item.set('itemIDs', []);
		}

		return {
			playlist: this._data.item
		};
	}

	@computed
	get playlists () {
		return this._items;
	}

	set playlists (playlists) {
		this._items = playlists;
	}

	@computed
	get hfmPicks () {
		return _(this.playlists)
			.filter({ isHFMPicks: true })
			.sortBy('HFMPicksPosition')
			.value();
	}

	@computed
	get hfmRadio () {
		return _(this.playlists)
			.filter({ isHFMRadio: true})
			.sortBy('label')
			.value();
	}

	@observable
	_currentPlaylist = {};

	@computed
	get currentPlaylist () {
		return this._currentPlaylist;
	}

	set currentPlaylist (currentPlaylist) {
		this._currentPlaylist = _.isString(currentPlaylist) ?
			this.getItemByID(currentPlaylist) : currentPlaylist;
	}

		/**
	 * Actions
	 */

	@action
	setCurrentPlaylist (playlist) {
		songsStore.currentSong = null;
		this.currentPlaylist = playlist;
	}


	@action
	async savePlaylist (opts = {}) {
		const { silent = false } = opts;
		const payload = { ...this.data.playlist.toPOJO() };

		this.isLoading = silent !== true;

		if (payload.itemIDs) {

			payload.itemIDs = _.compact(payload.itemIDs);
		}

		try {

			const route = routes.playlistCreate;
			const { data: newPlaylist } = await this.saveData(payload, route);

			runInAction('Update after saving new playlist', () => {
				this.playlists.unshift(newPlaylist);

				this.data.playlist.replace({
					itemIDs: []
				});

				toast.success('Playlist saved!');
			});
		} catch (err) {

			toast.error('Error saving playlist!');
			console.error('[ERROR: PlaylistStore.savePlaylist]', err);
		} finally {

			this.isLoading = false;
		}
	}

	@action
	async savePlaylistArtwork (change, opts = {}) {
		const { _id } = change;
		const {
			silent = false,
			onSuccess = () => {}
		} = opts;

		const payload = {
			...change,
			path: `playlist-images/${_id}`,
			type: this.changeTypes.UPDATE
		};

		this.isLoading = silent !== true;

		try {

			const route = routes.playlistArtworkUpload.replace(/\:_id/, _id);
			const { data: updatedPlaylist } = await this.saveData(payload, route);

			runInAction('Update after generating HFM Picks', () => {
				this.playlists = this.playlists.slice().map((playlist) => {
					return playlist._id === _id ? updatedPlaylist : playlist;
				});

				toast.success('Playlist saved!');
			});
		} catch (err) {

			toast.error('Error saving playlist!');
			throw err;
		} finally {

			this.isLoading = false;
		}
	}


	@action
	setPlaylistType (playlistID, listType) {
		if (_.isNull(listType)) {
			return;
		}

		if (_.isEmpty(playlistID)) {
			this.data.playlist.set('listType', listType);
			return;
		}

		const index = this.getItemIndex({ _id: playlistID });

		this.playlists[index].listType = listType;
	}

	@action
	setPlaylistGenre (playlistID, genre) {
		if (_.isNull(genre)) {
			return;
		}

		if (_.isEmpty(playlistID)) {
			this.data.playlist.set('genre', genre);
			return;
		}

		const index = this.getItemIndex({ _id: playlistID });

		this.playlists[index].genre = genre;
	}
	
	@action
	setPlaylistShow (playlistID, show) {
		if (_.isNull(show)) {
			return;
		}

		if (_.isEmpty(playlistID)) {
			this.data.playlist.set('showOnFrontPage', show);
			return;
		}

		const index = this.getItemIndex({ _id: playlistID });

		this.playlists[index].showOnFrontPage = show;
	}

	@action
	clearPlaylistInfo () {
		if (_.isEmpty(playlistID)) {
			this.data.playlist.set('title', '');
			this.data.playlist.set('itemIDs', []);
			this.data.playlist.set('genre', '');
			this.data.playlist.set('listType', '');
			this.data.playlist.set('showOnFrontPage', '');

			return;
		}
	}


	@action setPlaylistTitle (title) {
		this.data.playlist.set('title', title);
	}
	@action
	addSongToPlaylist (playlistID, songID) { // LEGACY SHIM
		this.addItemToPlaylist (playlistID, songID);
	}

	@action
	addItemToPlaylist (playlistID, itemID) {
		if (_.isNull(itemID)) {
			return;
		}

		if (_.isEmpty(playlistID)) {
			
			const itemIDs = this.data.playlist.get('itemIDs') || [];
			itemIDs.unshift(itemID);
			this.data.playlist.set('itemIDs', itemIDs);

			return;
		}

		const index = this.getItemIndex({ _id: playlistID });

		if (_.isEmpty(this.playlists[index].itemIDs)) {
			this.playlists[index].itemIDs = observable([]);
		}
		this.playlists[index].itemIDs.unshift(itemID);
	}

	@action
	removeSongFromPlaylist (playlistID, songID) { // LEGACY SHIM
		this.removeItemFromPlaylist (playlistID, songID);
	}

	@action
	removeItemFromPlaylist (playlistID, itemID) {
		if (_.isNull(itemID)) {
			return;
		}

		if (_.isEmpty(playlistID)) {

			const itemIDs = (this.data.playlist.get('itemIDs') || []).filter((_id) => _id !== itemID);
			this.data.playlist.set('itemIDs', itemIDs);

			return;
		}

		const index = this.getItemIndex({ _id: playlistID });

		this.playlists[index].itemIDs =
			this.playlists[index].itemIDs.filter((_id) => _id !== itemID);
	}

	@action
	reorderPlaylist (result, playlistID) {

		if (_.isEmpty(playlistID)) {

			const playlist = this.data.playlist;
			const itemIDs = this.data.playlist.get('itemIDs') || [];

			const { source: { index: startIndex }, destination: { index: endIndex } } = result;
			const reordered = Array.from(itemIDs.slice());
			const [ removed ] = reordered.splice(startIndex, 1);
	
			reordered.splice(endIndex, 0, removed);
			this.data.playlist.set('itemIDs', reordered);
			return;
		}

		const index = this.getItemIndex({ _id: playlistID });

		const { source: { index: startIndex }, destination: { index: endIndex } } = result;
		const reordered = Array.from(this.playlists[index].itemIDs.slice());
		const [ removed ] = reordered.splice(startIndex, 1);

		reordered.splice(endIndex, 0, removed);
		this.playlists[index].itemIDs = reordered;
	}

	@action 
	reorderListSet (result) {
		if (_.isNull(result)) {
			return;
		}
		const movedListIndex = this.getItemIndex({ _id: result.draggableId })
		const genre = this.playlists[movedListIndex].genre;
		const listsByGenre = this.getPlaylistsByGenre(genre);

		const { source: { index: startIndex }, destination: { index: endIndex } } = result;
		const reordered = listsByGenre.slice();
		const [ removed ] = reordered.splice(startIndex, 1);

		reordered.splice(endIndex, 0, removed);

		for (let i = 0; i < reordered.length; i++) {
			const thisListIndex = this.getItemIndex({ _id: reordered[i]._id });
			this.playlists[thisListIndex].position = i+1;
			this.updatePlaylist(this.playlists[thisListIndex]);
		}
	}

	@action
	async savePlaylistOrder (orderedItems = [], opts = {}) {
		if (_.isEmpty(orderedItems)) {
			return;
		}

		const { silent = false } = opts;
		this.isLoading = silent !== true;

		try {
			const updates = orderedItems.map((playlist, index) => {
				const _id = playlist._id || playlist.id;
				const position = index + 1;
				return this.updateItem({ _id, position }, { silent: true });
			});

			const updatedPlaylists = await Promise.all(updates);

			runInAction('Update after saving playlist order', () => {
				this.playlists = this.playlists.slice().map((playlist) => {
					const updated = updatedPlaylists.find((updatedPlaylist) => updatedPlaylist && (updatedPlaylist._id === playlist._id || updatedPlaylist.id === playlist.id));
					return updated || playlist;
				}).sort((a, b) => a.position - b.position);
			});

			toast.success('Playlist order saved!');
		} catch (err) {
			toast.error('Error saving playlist order!');
			console.error('[ERROR: PlaylistStore.savePlaylistOrder]', err);
		} finally {
			if (silent !== true) {
				this.isLoading = false;
			}
		}
	}

	@action
	async search (search) {
		try {

			const { data } = await this.ax
				.get(routes.searchGenres.replace(/:search/, search));
			this.searchResults = data;
		} catch (err) {

			console.log('[FETCH GENRES ERROR]', err);
			return [];
		}
	}

	@action
	async deletePlaylist (playlist) {
		await this.deleteItem(playlist);
		toast.success('Playlist deleted!');
	}

	getPlaylistByID (value) {
		// return  this.getItemByID({ _id });

		if (_.isString(value)) {

			return _.first(this._items.filter(({ _id }) => _id === value));
		}

		if (_.isObject(value) && _.isArray(value.slice())) {

			return _(value.slice())
				.map((_id) => this.getPlaylistByID(_id))
				.compact()
				.value();
		}
	}

	getPlaylistsByGenre (value) {

		if (_.isString(value)) {

			return _.orderBy(this._items
								.filter(({ genre, listType }) => (genre === value && listType != 'NEW_RELEASES'))
					, ['position']);
		}

		if (_.isObject(value) && _.isArray(value.slice())) {

			return _(value.slice())
				.map((genre) => this.getPlaylistsByGenre(genre))
				.compact()
				.value();
		}
	}

	getNewReleases () {
		const newRel = this._items.filter(({ listType }) => listType == 'NEW_RELEASES');
		if (newRel.length > 0) {
			// return this._items.filter(({ listType }) => listType == 'NEW_RELEASES');
			return this._items.filter(({ listType }) => listType == 'NEW_RELEASES')[0];
		} else {
			return false;
		}
	}

	@action
	async updatePlaylist (change, opts = {}) {
		const { _id = null } = change;

		if (_.isNull(_id)) {
			console.warn("_.isNull(_id)")
			return;
		}

		const { silent = false } = opts;
		const payload = {
			...change,
			type: this.changeTypes.UPDATE
		};

		console.log("payload");
		console.log(payload);

		this.isLoading = silent !== true;

		if (payload.itemIDs) {

			payload.itemIDs = _.compact(payload.itemIDs);
		}

		try {

			const newPlaylist = await this.updateItem(payload);
			runInAction('Update after updating playlist', () => {
				this.playlists = this.playlists.slice().map((playlist) => (
					playlist.id === _id ? newPlaylist : playlist
				));
				toast.success('Playlist updated!');
			});
		} catch (err) {

			toast.error('Error updating playlist!');
			throw err;
		} finally {

			this.isLoading = false;
		}
	}
}

const playlistStore = new PlaylistStore();
export default playlistStore;
